import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { useEffect, useState } from 'react';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const GstReportPdf = ({ data }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [report, setReport] = useState(null);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Calculate grand total for all services (adjust this for your specific data)
  const grandTotal = data.reduce((total, service) => total + (service.total_amt || 0), 0);

  useEffect(() => {
    // Extract the 'report' query parameter
    const params = new URLSearchParams(window.location.search);
    const reportParam = JSON.parse(params.get('refId')).report;
    setReport(reportParam);
  }, []);

  useEffect(() => {
    console.log('HELLO REF ID', report);
  }, [report]);

  const groupDataByProduct = (data) => {
    const grouped = {};

    data &&
      data.forEach((receipt) => {
        receipt?.add_details?.forEach((detail) => {
          const productName = detail.product_name;
          if (!grouped[productName]) {
            grouped[productName] = [];
          }
          grouped[productName].push({
            ...detail,
            grn_no: receipt.grn_no,
            grn_date: receipt.grn_date,
            invoice_no: receipt.invoice_no,
            invoice_date: receipt.invoice_date,
            net_amt: receipt.net_amt,
            total_amt: receipt.total_amt,
            total_qty: receipt.total_qty,
            remarks: receipt.remarks
          });
        });
      });

    return grouped;
  };

  const groupedData = groupDataByProduct(data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="GST Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            {/* Header row for both reports */}
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '9%' }} content="Sr No." />
              <Text style={styles.columnHeader} content="Date" />
              <Text style={styles.columnHeader} content="Bill No." />
              <Text style={styles.columnHeader} content="Challan No." />
              <Text style={{ ...styles.columnHeader, width: '30%' }} content="Product Name" />
              <Text style={styles.columnHeader} content="Quantity" />
              <Text style={styles.columnHeader} content="GST%" />
              <Text style={styles.columnHeader} content="Taxable Value" />
              <Text style={styles.columnHeader} content="Integrated Tax Amount" />
              <Text style={styles.columnHeader} content="Central Tax Amount" />
              <Text style={styles.columnHeader} content="State Tax Amount" />
              <Text style={styles.columnHeader} content="Total Tax Amount" />
            </View>
            {/* Render data based on the report type */}
            {report === 'gst_purchase_register' && data && data.length > 0 ? (
              data.map((receipt, index) =>
                receipt.add_details.map((detail, detailIndex) => (
                  <View
                    key={`${index}-${detailIndex}`}
                    style={{ ...styles.row, backgroundColor: COLORS[detailIndex % COLORS.length] }}
                  >
                    <Text style={{ ...styles.columnContent, width: '8%' }} content={`${index + 1}`} />
                    <Text style={styles.columnContent} content={formatDate(receipt.grn_date)} />
                    <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={receipt.invoice_no} />
                    <Text style={styles.columnContent} content={receipt.grn_no} />
                    <Text
                      style={{ ...styles.columnContent, width: '25%', textAlign: 'left' }}
                      content={detail.product_name}
                    />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.bill_qty} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.gst} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.taxable} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.igst} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.cgst} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.sgst} />
                    <Text
                      style={{ ...styles.columnContent, textAlign: 'right', marginRight: '15px' }}
                      content={detail.net_amt - detail.taxable}
                    />
                  </View>
                ))
              )
            ) : report === 'gst_sale_register' && data && data.length > 0 ? (
              data.map((sale, index) =>
                sale.productDetails.map((product, productIndex) => (
                  <View
                    key={`${index}-${productIndex}`}
                    style={{ ...styles.row, backgroundColor: COLORS[(index + productIndex) % COLORS.length] }}
                  >
                    <Text style={{ ...styles.columnContent, width: '8%' }} content={index + 1} />
                    <Text style={styles.columnContent} content={formatDate(sale.createdAt)} />
                    <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={sale.inv_no} />
                    <Text style={styles.columnContent} content={''} />
                    <Text
                      style={{ ...styles.columnContent, width: '25%', textAlign: 'left' }}
                      content={product.product_name?.name || 'N/A'}
                    />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.bill_qty || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.gst || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.amount || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={''} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.cgst || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.sgst || 'N/A'} />
                    <Text
                      style={{ ...styles.columnContent, textAlign: 'right', marginRight: '15px' }}
                      content={product.taxable || 'N/A'}
                    />
                  </View>
                ))
              )
            ) : report === 'gst_item_wise_purchase_register' && Object.keys(groupedData).length > 0 ? (
              Object.keys(groupedData).map((productName, index) => (
                <View key={index} style={{ marginBottom: 20 }}>
                  {/* Product heading */}
                  <Text style={styles.productHeading} content={productName} />
                  {/* Render details for each product */}
                  {groupedData[productName].map((detail, detailIndex) => (
                    <View
                      key={`${index}-${detailIndex}`}
                      style={{ ...styles.row, backgroundColor: COLORS[detailIndex % COLORS.length] }}
                    >
                      <Text style={{ ...styles.columnContent, width: '8%' }} content={`${index + 1}`} />
                      <Text style={styles.columnContent} content={formatDate(detail.grn_date)} />
                      <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={detail.invoice_no} />
                      <Text style={styles.columnContent} content={detail.grn_no} />
                      <Text
                        style={{ ...styles.columnContent, width: '25%', textAlign: 'left' }}
                        content={detail.product_name}
                      />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.bill_qty} />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.gst} />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.taxable} />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.igst} />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.cgst} />
                      <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={detail.sgst} />
                      <Text
                        style={{ ...styles.columnContent, textAlign: 'right', marginRight: '15px' }}
                        content={detail.taxable + detail.gst}
                      />
                    </View>
                  ))}
                </View>
              ))
            ) : report === 'gst_item_wise_sale_register' && data && data.length > 0 ? (
              data.map((sale, index) =>
                sale.productDetails.map((product, productIndex) => (
                  <View
                    key={`${index}-${productIndex}`}
                    style={{ ...styles.row, backgroundColor: COLORS[(index + productIndex) % COLORS.length] }}
                  >
                    <Text style={{ ...styles.columnContent, width: '8%' }} content={index + 1} />
                    <Text style={styles.columnContent} content={formatDate(sale.createdAt)} />
                    <Text style={{ ...styles.columnContent, textAlign: 'left' }} content={sale.inv_no} />
                    <Text style={styles.columnContent} content={''} />
                    <Text
                      style={{ ...styles.columnContent, width: '25%', textAlign: 'left' }}
                      content={product.product_name?.name || 'N/A'}
                    />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.bill_qty || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.gst || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.amount || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={''} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.cgst || 'N/A'} />
                    <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={product.sgst || 'N/A'} />
                    <Text
                      style={{ ...styles.columnContent, textAlign: 'right', marginRight: '15px' }}
                      content={product.taxable || 'N/A'}
                    />
                  </View>
                ))
              )
            ) : (
              <Text style={styles.columnContent}>No data available</Text>
            )}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
